/** Sono state messe tutte queste classi in un unico file per evitare priblemi di "Maximum call stack size exceeded" degli import
    legati alle dipendenze circolari */

import { convertByEnumName, LicenseModuleEnum } from "../License/LicenseModuleEnum";
import { DeviceTreeNodeTypeEnum } from "./DeviceTreeNodeTypeEnum";

export class DeviceTreeNode {
    type: DeviceTreeNodeTypeEnum;
    id: string | number;
    name: string;

    constructor(obj: any) {
        if (obj) {
            if (obj.Type != null && Object.values(DeviceTreeNodeTypeEnum).includes(obj.Type)) this.type = obj.Type;
            this.id = obj.Id;
            this.name = obj.Name;
        }
    }

    static staticParse(node: any): DeviceTreeNode {
        if (node.Type != null && Object.values(DeviceTreeNodeTypeEnum).includes(node.Type)) {
            var nodeType = node.Type;

            switch (nodeType) {
                case DeviceTreeNodeTypeEnum.Folder:
                    return new FolderDeviceTreeNode(node);
                case DeviceTreeNodeTypeEnum.Device:
                    return new InstallationDeviceTreeNode(node);
                default:
                    return null;
            }
        }
        return null;
    }
}

export class FolderDeviceTreeNode extends DeviceTreeNode {
    children: DeviceTreeNode[] = [];
    organizationId: number = -1;

    constructor(obj: any) {
        super(obj);
        if (obj) {
            if (obj.Children && obj.Children.length > 0) {
                this.children = [];
                obj.Children.forEach((childNode) => {
                    var parsedNode = DeviceTreeNode.staticParse(childNode);
                    if (parsedNode) this.children.push(parsedNode);
                });
            }

            this.organizationId = obj.OrganizationId;
        }
    }
}

export class InstallationDeviceTreeNode extends DeviceTreeNode {
    license: LicenseModuleEnum = LicenseModuleEnum.None;

    constructor(obj: any) {
        super(obj);
        if (obj) {
            if (obj.License) this.license = convertByEnumName(obj.License);
        }
    }
}
